export default __webpack_public_path__ + "static/media/ei_lock.86cc8a52.svg";